import { useState, useCallback, useMemo, useEffect } from 'react';
import { useForm } from 'src/components/Form';
import ModalDialog, { ModalCloseHandler } from 'src/components/ModalDialog';
import { useUserRoles } from 'src/auth';
import { Box, Button } from '@mui/material';
import { getSolutionSettingsADXTableFormFields } from '../formFields';
import { SolutionAdxTablesItem, SolutionIndustrialFeatures } from '../../types';
import { useSolutionDetails } from '../../redux';
import SolutionFeatureInformation from '../../components/SolutionFeatureInfomation';

type Props = {
  item?: SolutionAdxTablesItem;
  title: string;
  loading?: boolean;
  open: boolean;
  onClose: ModalCloseHandler;
  onSubmit: (values: SolutionAdxTablesItem) => void;
  confirmBtnText?: string;
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
};

function SolutionAdxTableEditModal({
  item,
  title,
  loading,
  open,
  onClose,
  onSubmit,
  confirmBtnText = 'Create',
}: Props) {
  const [data, loadingSolution] = useSolutionDetails();
  const [cachePeriod, setCachePeriod] = useState<number>(
    item?.cachePeriod ?? 0
  );
  const [retentionPeriod, setRetentionPeriod] = useState<number>(
    item?.retentionPeriod ?? 0
  );
  const { isPlatformReader } = useUserRoles();
  const isDataIngested = data?.solutionIndustrialFeatures?.includes(
    SolutionIndustrialFeatures.IsDataIngested
  );

  const handleCacheLimit = ({ target }) => {
    setCachePeriod(target.value);
  };
  const handleRetentionLimit = ({ target }) => {
    setRetentionPeriod(target.value);
  };

  const [form, handleSubmit, setValue] = useForm({
    visibleValuesOnly: true,
    values: item,
    fields: getSolutionSettingsADXTableFormFields(
      !!item,
      item?.tableName ?? '',
      cachePeriod,
      retentionPeriod,
      handleCacheLimit,
      handleRetentionLimit,
      isPlatformReader,
      !isDataIngested
    ),
    // onChange,
    sx: containerStyle,
    onSubmit,
  });

  return (
    <ModalDialog
      open={open}
      title={title}
      confirmBtnText={confirmBtnText}
      loading={loading}
      onClose={onClose}
      maxWidth="sm"
      titleStyle={{ height: '67px' }}
      showCancelBtn={false}
      showConfirmBtn={false}
      contentStyle={{ paddingRight: '0px' }}
    >
      {!isDataIngested && (
        <SolutionFeatureInformation
          featureInfo="Data ingestion is disabled since this feature was not opted
                          during solution onboarding. To start accessing it, please
                          edit the solution and select the feature."
        />
      )}
      {form}
      <Box textAlign="right" mt={3} style={{ paddingRight: '20px' }}>
        <Button onClick={onClose} variant="outlined" sx={{ mr: 2 }}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} variant="contained">
          {!item ? 'Create' : 'Save'}
        </Button>
      </Box>
    </ModalDialog>
  );
}

export default SolutionAdxTableEditModal;
